import React, { useRef } from "react";
import { Link, Image, Text, isExperienceEditorActive } from "@sitecore-jss/sitecore-jss-react";
import Carousel from "@isos/foundation/dist/Helpers/containers/Carousel";
import Slide from "@isos/foundation/dist/Helpers/containers/Slide";
import WithFieldsCheck from "@isos/foundation/dist/Helpers/containers/WithFieldsCheck";
import LazyLoad from "@isos/foundation/dist/Helpers/components/LazyLoad";
import { useIsInView } from "@isos/foundation/dist/Utils/hooksUtil";
import "./index.css";
const LogoCarousel = ({
  fields
}) => {
  const isEditing = isExperienceEditorActive();
  const componentRef = useRef();
  const checkView = useIsInView(componentRef);
  return /*#__PURE__*/React.createElement("div", {
    className: `logo-carousel animation ${checkView ? "animation--load-in" : ""} fade-in-up`,
    ref: componentRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrapper logo-carousel__wrapper"
  }, /*#__PURE__*/React.createElement(Text, {
    className: "logo-carousel__title title-text-gradient",
    tag: "h2",
    field: fields.Title
  }), /*#__PURE__*/React.createElement(Carousel, {
    customClass: "logo",
    slides: "5",
    mobileSlides: "3"
  }, (fields.Logos || []).map((item, i) => {
    const itemFields = item.fields;
    return /*#__PURE__*/React.createElement(Slide, {
      key: i
    }, /*#__PURE__*/React.createElement(Text, {
      tag: "h4",
      className: "hidden-accessible",
      field: itemFields.Title
    }), itemFields.Link && itemFields.Link.value && itemFields.Link.value.href ? /*#__PURE__*/React.createElement(Link, {
      className: "carousel__slider-item-link",
      field: itemFields.Link,
      tabindex: "-1",
      title: itemFields.Image.value.alt
    }, /*#__PURE__*/React.createElement(LazyLoad, {
      customClass: "carousel__image-container"
    }, /*#__PURE__*/React.createElement(Image, {
      className: "carousel__image",
      field: itemFields.Image,
      imageParams: {
        w: 140,
        h: "auto",
        mw: 140
      },
      alt: itemFields.Image.value.alt
    }))) : /*#__PURE__*/React.createElement(LazyLoad, {
      customClass: "carousel__image-container"
    }, /*#__PURE__*/React.createElement(Image, {
      className: "carousel__image",
      field: itemFields.Image,
      imageParams: {
        w: 140,
        h: "auto",
        mw: 140
      }
    })));
  })), (fields.Link && fields.Link.value && fields.Link.value.href !== "" || isEditing) && /*#__PURE__*/React.createElement(Link, {
    className: "logo-carousel__link button button--secondary",
    field: fields.Link
  })));
};
export default WithFieldsCheck(LogoCarousel);